/**
 * Полоса над лентой: почему она не живая и что нажать.
 *
 * Без этой строки демо выглядит поломкой сканера. Человек видит вилки без имён
 * контор, решает, что площадки отвалились, и уходит — вместо того, чтобы нажать
 * одну кнопку. Поэтому у каждого урезанного состояния здесь есть и причина, и
 * действие: молчаливое ограничение — это потерянный человек, а не защита.
 *
 * Когда всё в порядке, полосы нет вовсе. Правило экрана: он молчит, когда
 * сошлось, и говорит только при проблеме.
 */

import { useSession } from './session';

export function Notice(): React.ReactElement | null {
  const known = useSession((s) => s.known);
  const me = useSession((s) => s.me);
  const waiting = useSession((s) => s.waiting);

  if (!known) return null;

  if (me.authenticated && me.reason === 'frozen') {
    return (
      <p className="nx-notice nx-notice--warn">
        доступ приостановлен: похоже, лентой пользуются с нескольких сторон. Нажмите{' '}
        <b>«это я»</b> в Telegram, и я сразу верну доступ.
      </p>
    );
  }
  if (me.authenticated && me.reason === 'device_pending') {
    return (
      <p className="nx-notice nx-notice--warn">
        новый экран. Подтвердите его в Telegram, до этого имена контор и купоны скрыты.
      </p>
    );
  }
  if (me.authenticated) return null;
  if (!me.possible) return null;

  return (
    <p className="nx-notice">
      демо: конторы не названы, купоны закрыты.{' '}
      {waiting === null ? (
        <button type="button" onClick={() => void useSession.getState().begin()}>
          войти через Telegram
        </button>
      ) : (
        <a href={waiting.link} target="_blank" rel="noreferrer">
          нажмите «начать» в боте, и лента откроется сама
        </a>
      )}
    </p>
  );
}
